<template>
  <section>
    <md-toolbar class="md-transparent md-title" md-elevation="0">
      <md-button class="md-icon-button" @click="closeWindow">
        <md-icon>close</md-icon>
      </md-button>
      <span>Add a new</span>
    </md-toolbar>
    <md-list>
      <md-list-item
        @click="selectAdminMenuOption('NewAppointment')"
        to="/admin/appointment"
      >
        <md-icon>event</md-icon>
        <span class="md-list-item-text">Appointment</span>
      </md-list-item>

      <!-- TODO hide it for now  -->
      <md-list-item
        style="display: none"
        @click="selectAdminMenuOption('NewClient')"
        to="/admin/client"
      >
        <md-icon>face</md-icon>
        <span class="md-list-item-text">Client</span>
      </md-list-item>
      <md-list-item
        @click="selectAdminMenuOption('NewTreatment')"
        to="/admin/treatment"
      >
        <md-icon>eco</md-icon>
        <span class="md-list-item-text">Treatment</span>
      </md-list-item>
    </md-list>
  </section>
</template>

<script>
import { eventBus } from "../eventbus";

export default {
  name: "AdminMenuOptions",
  methods: {
    selectAdminMenuOption: function (option) {
      eventBus.selectAdminMenuOption(option);
      this.closeWindow();
    },
    closeWindow: function () {
      eventBus.openCloseAdminRightDrawer(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  min-height: 300px;
  overflow: hidden;
  position: relative;
  border: 1px solid rgba(#000, 0.12);
}

.md-drawer {
  width: 230px;
  max-width: calc(100vw - 125px);
}

.md-content {
  padding: 16px;
}
</style>